module.exports = __webpack_public_path__ + "static/media/esz-promo-background.dd78cb2e.png";